import React from "react";
import { Button, Form, Modal } from "react-bootstrap";
import CloseBtn from "../CloseBtn";
const PAYMENT_MODES = [
  "Cheque",
  "Payment Link",
  "PhonePe",
  "Razorpay",
  "Bank Transfer",
];
const PaymentModal = ({
  onHide,
  show,
  payModalData,
  setPayModalData,
  onSubmit,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <CloseBtn onClick={onHide} color="#bf352b" />
      <Modal.Header>
        <Modal.Title>Confirm Payment Received</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Payment Proof (Image/PDF) *</Form.Label>
            <Form.Control
              type="file"
              accept=".jpg,.jpeg,.png,.pdf"
              onChange={(e) =>
                setPayModalData((d) => ({
                  ...d,
                  file: e.target.files?.[0] || null,
                }))
              }
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Payment Mode *</Form.Label>
            <Form.Select
              value={payModalData.mode}
              onChange={(e) =>
                setPayModalData((d) => ({ ...d, mode: e.target.value }))
              }
            >
              <option value="">Select mode</option>
              {PAYMENT_MODES.map((m) => (
                <option key={m} value={m}>
                  {m}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-0">
            <Form.Label>Remark</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Add a note about the payment..."
              value={payModalData.remark}
              onChange={(e) =>
                setPayModalData((d) => ({ ...d, remark: e.target.value }))
              }
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onHide}
          disabled={payModalData.submitting}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={ onSubmit}
          disabled={payModalData.submitting}
        >
          {payModalData.submitting ? "Submitting..." : "Confirm & Update"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PaymentModal;
